export function makeTips(mat) {
  const matrix = mat;

  const size = matrix.length;
  const rowTips = [];

  const colTips = Array.from({ length: size }, () => []);

  //row
  matrix.forEach((row) => {
    let num = [];
    let count = 0;

    row.forEach((elem) => {
      if (elem === 1) {
        count++;
      } else if (count > 0) {
        num.push(count);
        count = 0;
      }
    });

    if (count > 0) num.push(count);
    rowTips.push(num);
  });

  //col
  for (let col = 0; col < size; col += 1) {
    let num = [];
    let count = 0;

    for (let row = 0; row < size; row += 1) {
      if (matrix[row][col] === 1) {
        count++;
      } else if (count > 0) {
        num.push(count);
        count = 0;
      }
    }

    if (count > 0) num.push(count);
    colTips[col] = num;
  }

  return { rowTips, colTips };
}
